var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay-drawer center-item",class:{ show: _vm.show, 'loading-text': _vm.loadingText }},[_c('a-icon',{staticStyle:{"font-size":"50px"},attrs:{"type":"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }